export default __webpack_public_path__ + "locales/sk/ChangePhoneDialog.json?hash=f985b967d0504336dfb2179da95c06b2";